// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__29Hbe","col":"CardReaderDesc_col__5tYBB","label":"CardReaderDesc_label__-9Avi"};